import { useState } from "react";
import "./FAQSection.css";

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const data = [
    {
      title: "Find Nearest Branch",
      content: "Locate the nearest branch easily and visit us for a smooth gold selling experience.",
    },
    {
      title: "Carry your Documents",
      content: "Bring valid ID proof and required documents for quick verification.",
    },
    {
      title: "Check Gold Purity & Rate",
      content: "We test your gold purity and provide live market-based pricing.",
    },
    {
      title: "Verify your KYC",
      content: "Complete quick KYC verification for a secure transaction.",
    },
    {
      title: "Payment as you wish!",
      content: "Receive instant payment via cash, bank transfer, or your preferred method.",
    },
  ];

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">

      <h2 className="faq-title">Simple Steps to Sell Gold</h2>

      <div className="faq-container">

        {data.map((item, index) => (
          <div
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            key={index}
            onClick={() => toggle(index)}
          >

            <div className="faq-question">
              <span>{item.title}</span>
              <span className="icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>

            <div className="faq-answer">
              <p>{item.content}</p>
            </div>

          </div>
        ))}

      </div>

    </section>
  );
}